import { useState } from 'react';
import { DocumentFile } from '../../common/types/types';
import MinusIcon from '../../assets/icons/minus-icon.svg';
import PlusIcon from '../../assets/icons/plus-icon.svg';
interface Props {
  files: DocumentFile[];
}

const DocumentImages = ({ files }: Props) => {
  const [selectedImage, setSelectedImage] = useState<number>(1);
  const [zoomLevel, setZoomLevel] = useState(80);

  let imageURL = ``;
  files.map((file, index) => {
    if (index === selectedImage) {
      imageURL = `data:image/png;base64,${file.content}`;
    }
  });
  const selectedImageChange = (index: number) => {
    setSelectedImage(index);
  };

  const handleZoomIn = () => {
    if (zoomLevel < 100) setZoomLevel(zoomLevel + 5);
  };

  const handleZoomOut = () => {
    if (zoomLevel > 30) {
      // Limit minimum zoom level
      setZoomLevel(zoomLevel - 5);
    }
  };

  return (
    <>
      <div className='document__invoice text-center relative'>
        <img className='document__invoice__image' src={imageURL} alt='' style={{ width: `${zoomLevel}%` }} />
        {/* <img className='document__invoice__image' src={TestImage} alt='' style={{ width: `${zoomLevel}%` }} />; */}
        <div className='controls'>
          <div className='controls__zoom-in' onClick={handleZoomIn}>
            <img src={PlusIcon} alt='Zoom In' />
          </div>
          <div className='controls__zoom-out' onClick={handleZoomOut}>
            <img src={MinusIcon} alt='Zoom Out' />
          </div>
        </div>
      </div>
      {/* <div className='document__invoice text-center'>
          <div className='zoomable-image-container'>
          <div className='image-wrapper'>
            <img className='document__invoice__image' src={TestImage} alt='' style={{ width: `${zoomLevel}%` }} />
          </div>
        </div> 
        <div className='controls'>
          <button onClick={handleZoomIn}>Zoom In</button>
          <button onClick={handleZoomOut}>Zoom Out</button>
        </div>
      </div> */}

      <div className='document__pages'>
        <div className='document__pages__box fixed'>
          {files.map((file, index) => {
            if (index >= 1) {
              const sideImageURL = `data:image/png;base64,${file.content}`;
              return <img className='document__pages__image' key={index} src={sideImageURL} alt='' onClick={() => selectedImageChange(index)} />;
            }
          })}
        </div>
      </div>
    </>
  );
};

export default DocumentImages;
